import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const baseMainnet: VToken[] = [
  {
    chainId: 8453,
    address: '0x7bBd1005bB24Ec84705b04e1f2DfcCad533b6D72',
    decimals: 8,
    symbol: 'vcbBTC_Core',
    underlyingToken: tokens[8453][2],
  },
  {
    chainId: 8453,
    address: '0xEB8A79bD44cF4500943bf94a2b4434c95C008599',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[8453][1],
  },
  {
    chainId: 8453,
    address: '0x3cb752d175740043Ec463673094e06ACDa2F9a2e',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[8453][3],
  },
  {
    chainId: 8453,
    address: '0x75201D81B3B0b9D17b179118837Be37f64fc4930',
    decimals: 8,
    symbol: 'vwsuperOETHb_Core',
    underlyingToken: tokens[8453][5],
  },
  {
    chainId: 8453,
    address: '0x133d3BCD77158D125B75A17Cb517fFD4B4BE64C5',
    decimals: 8,
    symbol: 'vwstETH_Core',
    underlyingToken: tokens[8453][6],
  },
];
